export const baseURL = process.env.REACT_APP_API_URL
export const REST_ID = '6440fac08850e6a57e884c03'
export type TContent = {
  value: string
  lang: string
}

export type TWorkingDay = {
  start: string
  end: string
  _id?: string
}
export type TWorkingTimeRestaurant = {
  monday: TWorkingDay
  tuesday: TWorkingDay
  wednesday: TWorkingDay
  thursday: TWorkingDay
  friday: TWorkingDay
  saturday: TWorkingDay
  sunday: TWorkingDay
}

export type TWorkingTime = {
  _id: string
  day: TContent[]
  start: string
  end: string
}
export type TLanding = {
  booking?: {
    photos: string[]
  }
  contacts?: {
    email: string
  }
  offlineMenu?: null
  _id: string
  title?: TContent[]
  description: TContent[]
  address: TContent[]
  location?: {
    coordinates: number[]
    type: string
  }
  mainImage: string
  mainSlider: string[]
  headerPhoto: string
  headerColor?: string
  workingTime: TWorkingTime[]
  slug: string
  countGuests?: number
  countDishes?: number
  countBottles?: number
  restaurant: string
  updatedAt: string
  metaDescription?: string
  metaKeywords?: string[]
  banketGallery: string[]
  banketMainImages: string[]
  banketContactPhone: string
  banketDescription: TContent[]
  banketEnabled: boolean
  banketMenu: string
  banketTerms: string
}

export const initialLanding = {
  booking: {
    photos: [''],
  },
  contacts: {
    email: '',
  },
  offlineMenu: null,
  _id: '',
  title: [
    {
      value: '',
      lang: '',
    },
    {
      value: '',
      lang: '',
    },
  ],
  description: [
    {
      value: '',
      lang: '',
    },
    {
      value: '',
      lang: '',
    },
  ],
  address: [
    {
      value: '',
      lang: '',
    },
    {
      value: '',
      lang: '',
    },
  ],
  location: {
    coordinates: [],
    type: '',
  },
  mainImage: '',
  mainSlider: [''],
  headerPhoto: '',
  headerColor: '',
  workingTime: [
    {
      day: [
        { value: '', lang: 'uk' },
        { value: ' ', lang: 'en' },
      ],
      start: '',
      end: '',
      _id: '',
    },
    {
      day: [
        { value: '', lang: 'uk' },
        { value: '', lang: 'en' },
      ],
      start: '',
      end: '',
      _id: '',
    },
  ],
  slug: '',
  countGuests: 0,
  countDishes: 0,
  countBottles: 0,
  restaurant: '',
  updatedAt: '',
  metaDescription: '',
  metaKeywords: [''],
  banketGallery: [],
  banketMainImages: [],
  banketContactPhone: '',
  banketDescription: [],
  banketEnabled: true,
  banketMenu: '',
  banketTerms: '',
}
export const initialPolitics = [
  { value: '', lang: 'uk' },
  { value: '', lang: 'en' },
]

export type TPolitics = TContent[]

export enum EHasDelivery {
  ALL = 'all',
  NOT = 'not',
  NOT_APP = 'notApp',
  NOT_WEB = 'notWeb',
}
export type TRestaurantData = {
  booking: {
    booking: {
      photos: [] | string[]
    }
  }
  enableBasket: boolean
  contacts: {
    contacts: {
      phone: string
      email: string
      social: { facebook: string; instagram: string; telegram: string }
    }
  }
  _id: string
  title: TContent[]
  description: TContent[]
  address: TContent[]
  location: {
    coordinates: [number, number]
    type: 'Point'
  }
  city: TContent[]
  mainImage: string
  hasDelivery: EHasDelivery
  slug: string
  mainSlider: string[]
  headerPhoto: string
  headerColor: string
  metaDescription: string
  metaKeywords: string[]
  deliveryConditions: TContent[]
  stocks: []
  workingTime: TWorkingTimeRestaurant & { id: string }
  deliveryTime: TWorkingTimeRestaurant & { id: string }
  deliveryPrice: { courier: number }
  isWorkingNow: boolean
  linkToOfflineMenu: null | string
  offlineMenu: string
  position: number
  createdAt: string
  updatedAt: string
  __v: 0
  minimalOrder: number
  userAgreement?: TContent[]
}
